import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatMenuModule } from '@angular/material/menu';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { AppComponent } from './app.component';
import { LoggerServiceModule } from './services/logger/logger.module';
import { DateConverteServiceModule } from './services/date-converter/date-converter.module';
import { RolesPermissionsModule } from './components/roles-permissions';
import { AuthModule } from './components/auth/auth.module';
import { MainEntryModule } from './components/main-entry';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './services/shared/shared.module';
import { AppRoutingModule } from './components/routing/app-routing.module';
import { NotificationModule } from './components/notifications';
import { AnalyticsService } from './services/analytics/analytics.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { TimeZoneInterceptor } from './interceptors/date-timezone.interceptor';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { KngLoaderModule } from 'kinetic-angular';

export function analyticsInitializerFactory(analyticsService: AnalyticsService): () => Promise<void>
{
	const serviceInjectionPromise: Promise<void> = analyticsService.injectAdobeLaunchScript();
	serviceInjectionPromise
		.then(() => analyticsService.initDataLayer());
	return () => serviceInjectionPromise;
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		AuthModule,
		HttpClientModule,
		RolesPermissionsModule,
		LoggerServiceModule,
		DateConverteServiceModule,
		KngLoaderModule,
		SharedModule,
		MainEntryModule,
		OverlayModule,
		MatMenuModule,
		MatTooltipModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule,
		NotificationModule,
		MatInputModule,
		MatDatepickerModule,
		MatNativeDateModule,
		ToastrModule.forRoot({
			timeOut: 10000,
			positionClass: 'toast-top-right',
			toastClass: 'kng-toast toast-container ngx-toastr',
			enableHtml: true,
			closeButton: true,
			preventDuplicates: true
		}),
		NgCircleProgressModule.forRoot({
			lazy: false
		})
	],
	providers: [
		Title,
		{ provide: APP_INITIALIZER, useFactory: analyticsInitializerFactory, deps: [AnalyticsService], multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: TimeZoneInterceptor, multi: true }
	],
	bootstrap: [ AppComponent, MsalRedirectComponent ],
	exports: []
})
export class AppModule {}
